import { Box, IconButton, Button, Input, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useAuth } from "../../../AuthContext";
import { tokens } from "../../../theme";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddIcon from '@mui/icons-material/Add';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import 'react-toastify/dist/ReactToastify.css';
import Nodata from '../../../assets/errors/nodata.png'; // Adjust the path as necessary

import LinkIcon from '@mui/icons-material/Link';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNews, setSelectedNews] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [newsToDelete, setNewsToDelete] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { getData, addData, updateData, deleteData } = useAuth();

  // Form state with new fields
  const [formData, setFormData] = useState({
    title: '',
    newsOrder: '',
    isFeafured: 'no', // Default to 'no'
    description: '',
    image: '',
    externalLink: '', // New externalLink field
    newsDate: '',
    dateCreated: ''
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getData('proccess.php', 'news_V2'); // Fetch news data
        if (response.success) {
          setNews(response.data);
        } else {
          toast.error(response.message || "Failed to load news data");
        }
      } catch (err) {
        toast.error("Network error: Failed to fetch news");
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  const handleAddClick = () => {
    setFormData({
      title: '',
      newsOrder: '',
      isFeafured: 'no', // Default to 'no'
      description: '',
      image: '',
      externalLink: '', // New externalLink field
      newsDate: new Date().toISOString().split('T')[0], // Set today's date as default
      dateCreated: new Date().toISOString().slice(0, 19).replace('T', ' ') // Format: YYYY-MM-DD HH:MM:SS
    });
    setOpenAddDialog(true);
  };

  const handleEditClick = (newsItem) => {
    setSelectedNews(newsItem);
    
    // Convert the isFeafured value to string 'yes' or 'no'
    let featuredValue = 'no';
    if (newsItem.isFeafured === 'yes' || newsItem.isFeafured === 1 || newsItem.isFeafured === true || newsItem.isFeafured === '1') {
      featuredValue = 'yes';
    }
    
    setFormData({
      title: newsItem.title || '',
      newsOrder: newsItem.newsOrder || '',
      isFeafured: featuredValue,
      description: newsItem.description || '',
      image: newsItem.image || '',
      externalLink: newsItem.externalLink || '', // New externalLink field
      newsDate: newsItem.newsDate ? newsItem.newsDate.split(' ')[0] : new Date().toISOString().split('T')[0],
      dateCreated: newsItem.dateCreated || new Date().toISOString().slice(0, 19).replace('T', ' ')
    });
    setOpenEditDialog(true);
  };

  const handleDeleteClick = (newsItem) => {
    setNewsToDelete(newsItem);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await deleteData('proccess.php', 'news_V2', newsToDelete.id); // Delete news by ID
      if (response.success) {
        toast.success(`News deleted successfully`);
        setNews(news.filter(item => item.id !== newsToDelete.id));
      } else {
        toast.error(response.message || "Failed to delete news");
      }
    } catch (err) {
      toast.error("Network error: Failed to delete news");
      console.error("Delete error:", err);
    }
    setOpenDeleteDialog(false);
    setNewsToDelete(null);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Form Data:",formData);
    
    try {
      let response;
      if (selectedNews) {
        // Update existing news - FIXED: Use submitData instead of formData
        response = await updateData('proccess.php', 'news_V2', formData, selectedNews.id);
        if (response.success) {
          toast.success(`News updated successfully`);
          setNews(response.data);
        }
      } else {
        // Add new news - FIXED: Use submitData instead of formData
        response = await addData('proccess.php', 'news_V2', formData);
        if (response.success) {
          toast.success(`News added successfully`);
          setNews(response.data);
        }
      }

      if (!response.success) {
        console.log("responce on news: ",response);
        toast.error(response.message || "Operation failed");
      }
    } catch (err) {
      toast.error("Network error: Operation failed");
      console.error("Operation error:", err);
    }
    setOpenEditDialog(false);
    setOpenAddDialog(false);
    setSelectedNews(null);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 20 },
    { field: "title", headerName: "News Title", flex: 1, minWidth: 120 },
    { field: "newsOrder", headerName: "Order", flex: 0.5, minWidth: 80 },
    { 
      field: "isFeafured", 
      headerName: "Featured", 
      flex: 0.5, 
      minWidth: 80,
      renderCell: (params) => (
        <Box>
          {params.value === 'yes' ? (
            <Typography 
              sx={{ 
                color: colors.green[400], 
                fontWeight: "bold",
                backgroundColor: colors.green[100],
                padding: "4px 8px",
                borderRadius: "4px",
                display: "inline-block"
              }}
            >
              Yes
            </Typography>
          ) : (
            <Typography 
              sx={{ 
                color: colors.orange[400],
                backgroundColor: colors.orange[100],
                padding: "4px 8px",
                borderRadius: "4px",
                display: "inline-block"
              }}
            >
              No
            </Typography>
          )}
        </Box>
      )
    },
    { field: "description", headerName: "Description", flex: 1.5, minWidth: 150 },
    {
      field: "image",
      headerName: "News Image",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Box width={50} height={50}>
          {params.value ? (
            <img
              src={`https://mindsinaction.com.na/assets/media/pictures/${params.value}`}
              alt={params.value || "News"}
              style={{ width: 50, height: 50, objectFit: "cover", cursor: "pointer" }}
              onClick={() => window.open(`https://mindsinaction.com.na/assets/media/pictures/${params.value}`, "_blank")}
            />
          ) : (
            "No image"
          )}
        </Box>
      )
    },
    {
      field: "externalLink",
      headerName: "External Link",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box>
          {params.value ? (
            <Box display="flex" alignItems="center" gap="4px">
              <LinkIcon fontSize="small" sx={{ color: colors.blue[400] }} />
              <Typography 
                sx={{ 
                  color: colors.blue[400],
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': {
                    color: colors.blue[600]
                  }
                }}
                onClick={() => window.open(params.value, "_blank")}
              >
                View Link
                <OpenInNewIcon fontSize="small" sx={{ ml: 0.5, fontSize: 14 }} />
              </Typography>
            </Box>
          ) : (
            <Typography color="gray">No link</Typography>
          )}
        </Box>
      )
    },
    { 
      field: "newsDate", 
      headerName: "News Date", 
      flex: 0.8, 
      minWidth: 100,
      renderCell: (params) => (
        <Typography>
          {params.value ? new Date(params.value).toLocaleDateString() : ''}
        </Typography>
      )
    },
    { 
      field: "dateCreated", 
      headerName: "Date Created", 
      flex: 0.8, 
      minWidth: 120,
      renderCell: (params) => (
        <Typography>
          {params.value ? new Date(params.value).toLocaleString() : ''}
        </Typography>
      )
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box display="flex" gap="8px">
          <IconButton
            onClick={() => handleEditClick(params.row)}
            sx={{ color: colors.blue[400] }}
          >
            <EditNoteOutlinedIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDeleteClick(params.row)}
            sx={{ color: colors.orange[400] }}
          >
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  const NoDataOverlay = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        color={colors.dark[400]}
      >
        <img
          src={Nodata}
          alt="No data"
          style={{ width: 150, marginBottom: 16 }}
        />
        <Typography variant="h6">No news available</Typography>
      </Box>
    );
  };

  return (
    <Box m={"10px"}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Add/Edit Dialog */}
      <Dialog
        open={openEditDialog || openAddDialog}
        onClose={() => {
          setOpenEditDialog(false);
          setOpenAddDialog(false);
          setSelectedNews(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{selectedNews ? "Edit News" : "Add New News"}</DialogTitle>
        <DialogContent>
          <Form onSubmit={handleSubmit} style={{ width: "100%", padding: "1rem" }}>
            <Box display={"flex"} gap={"1rem"} width={"100%"} mb={"1rem"} flexWrap="wrap">
              <TextField
                style={{ width: "100%" }}
                id="title"
                name="title"
                label="News Title"
                variant="standard"
                value={formData.title}
                onChange={handleFormChange}
                required
              />
              
              <Box display="flex" gap="1rem" width="100%">
                <TextField
                  style={{ width: "50%" }}
                  id="newsOrder"
                  name="newsOrder"
                  label="Order"
                  variant="standard"
                  type="number"
                  value={formData.newsOrder}
                  onChange={handleFormChange}
                  required
                />
                
                <FormControl component="fieldset" style={{ width: "50%" }}>
                  <FormLabel component="legend">Featured News</FormLabel>
                  <RadioGroup
                    row
                    id="isFeafured"
                    name="isFeafured"
                    value={formData.isFeafured}
                    onChange={handleFormChange}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Box>
              
              <TextField
                style={{ width: "100%" }}
                id="description"
                name="description"
                label="Description"
                variant="standard"
                multiline
                minRows={4}
                maxRows={12}
                value={formData.description}
                onChange={handleFormChange}
                required
              />
              
              {/* New External Link Field */}
              <TextField
                style={{ width: "100%" }}
                id="externalLink"
                name="externalLink"
                label="External Link (URL)"
                variant="standard"
                type="url"
                value={formData.externalLink}
                onChange={handleFormChange}
                placeholder="https://example.com/news-article"
                helperText="Optional: Link to full article or external source"
                InputProps={{
                  startAdornment: (
                    <LinkIcon sx={{ color: "gray", mr: 1, fontSize: 20 }} />
                  ),
                }}
              />
              
              <Box display="flex" gap="1rem" width="100%">
                <TextField
                  style={{ width: "50%" }}
                  id="newsDate"
                  name="newsDate"
                  label="News Date"
                  variant="standard"
                  type="date"
                  value={formData.newsDate}
                  onChange={handleFormChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
                
                <TextField
                  style={{ width: "50%" }}
                  id="dateCreated"
                  name="dateCreated"
                  label="Date Created"
                  variant="standard"
                  type="datetime-local"
                  value={formData.dateCreated}
                  onChange={handleFormChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              </Box>
              
              <Box width={"100%"}>
                <label>News Image</label>
                <Input
                  type="file"
                  style={{ width: "100%", marginTop: "0.5rem" }}
                  id="image"
                  name="image"
                  onChange={handleFileChange}
                  required={!selectedNews}
                />
                {formData.image && typeof formData.image === 'string' && (
                  <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                    Current image: {formData.image}
                  </Typography>
                )}
              </Box>
            </Box>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenEditDialog(false);
              setOpenAddDialog(false);
              setSelectedNews(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            sx={{ backgroundColor: colors.blue[400] }}
            variant="contained"
            endIcon={<SendIcon />}
          >
            {selectedNews ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete "{newsToDelete?.title}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button
            onClick={handleDeleteConfirm}
            sx={{ backgroundColor: colors.red[400] }}
            variant="contained"
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Box mb={"30px"} ml={"15px"} mr={"15px"} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
        <Box flex={1}>
          <Typography
            variant="h4"
            color={colors.dark[400]}
            fontWeight={"bold"}
            sx={{ mb: "5px" }}
          >
            News Management
          </Typography>
          <Typography variant="h5" color={colors.blue[400]}>
            Manage news
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddClick}
          sx={{
            backgroundColor: colors.blue[400],
            '&:hover': {
              backgroundColor: colors.blue[500],
            }
          }}
        >
          Add News
        </Button>
      </Box>
      <Divider component="" />
      <Box sx={{ height: "45vh", width: "100%" }} backgroundColor={colors.dark[300]} padding={".2rem"} mt={"1rem"}>
        <DataGrid
          rows={news}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          sx={{
            border: "none",
            ".MuiDataGrid-cell": {
              borderBottom: "none",
              backgroundColor: "none"
            },
            ".MuiDataGrid-toolbarContainer": {
              padding: "10px",
              backgroundColor: colors.primary[900],
              borderBottom: "none",
            },
            ".MuiDataGrid-quickFilter": {
              padding: "8px",
              borderRadius: "4px",
              border: `1px solid ${colors.primary[100]}`,
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: colors.primary[900],
            },
            ".MuiDataGrid-footerContainer": {
              backgroundColor: colors.primary[900],
            },
          }}
          slots={{
            toolbar: () => (
              <div>
                <GridToolbarQuickFilter />
              </div>
            ),
            noRowsOverlay: NoDataOverlay,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: {
                debounceMs: 500,
                placeholder: "Search...",
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default News;